import React, { FC } from 'react';
import { Typography } from 'antd';
import { Card } from 'components/card';
import { Header } from 'components/header';
import { ChartPieIcon } from 'components/icons';
import { ZP_INFO } from 'src/config';
import styles from './styles.less';

const { Text } = Typography;

export const ZPBlock: FC = () => {
  const TITLE = 'ZP';

  const onClick = (): void => {
    window.open(ZP_INFO, '_blank')?.focus();
  };

  return (
    <Card
      title={TITLE}
      icon={<ChartPieIcon />}
      iconClassNames={styles['icon-class']}
      containerClassNames={styles['card']}
      onClick={onClick}
    >
      <Header level={1} className={styles['text-align-left']}>
        $X XXX
      </Header>
      <Text type="secondary">In progress</Text>
    </Card>
  );
};
